import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { ModalService } from '../../../services/modal/modal.service';
import { OrderModel, OrderServiceProxy, PaymentCreateModel } from '../../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { ToastrService } from '../../../services/toastr/toastr.service';
import { ErrorService } from '../../../services/error/error.service';

@Component({
    selector: 'app-modal-payment-order',
    templateUrl: './modal-payment-order.component.html',
    styleUrl: './modal-payment-order.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class ModalPaymentOrderComponent implements OnInit {

  @Input() orderId: string = '';
  @Input() order: OrderModel = new OrderModel();
  @Output() change = new EventEmitter<boolean>(false);

  paymentForm: PaymentCreateModel = new PaymentCreateModel();

  isLoadingSend: boolean = false;

  constructor(private toastrService: ToastrService, private errorService: ErrorService, private modalService: ModalService, private _orderService: OrderServiceProxy, private destroyService: DestroyService) { }

  ngOnInit(): void {
    this.initialize();
  }

  closeModal() {
    this.modalService.closeModal();
    this.clearFormData();
  }
  initialize() {
    this.paymentForm.amount = this.order.total;
    this.paymentForm.currency = 'usd'
  }

  pay() {
    this.isLoadingSend = true;
    this._orderService.pay(this.orderId, this.paymentForm)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        console.log(res);
        this.isLoadingSend = false;
        this.change.emit(true);
        this.closeModal();
        this.toastrService.showSuccessToastr('Заказ успешно оплачен!');
      }, error => {
        console.error(error);
        this.isLoadingSend = false;
        this.errorService.handleError(error, 'Не удалось оплатить заказ. Попробуйте позже.');
    })
  }

  clearFormData() {
    this.paymentForm = new PaymentCreateModel();
    this.initialize();
  }

}
